/* POKELAGERET: Globo sidebar tweaks.
   1) Move Globo's "Search products" form into the collection hero when the page
      has one (data-pkl-search-holder); otherwise, on desktop, into the top of
      the filter sidebar. The product count and Show/Sort controls
      stay above the grid. On narrow screens the sidebar is an off-canvas
      drawer, so the form stays above the grid there.
   2) Display-only rename of a few English filter values that come from
      product data (the language metafield). Product data is untouched.
   Globo re-renders on every filter change, so both run whenever the DOM changes. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var moving = false;

  /* --- 2) value display names (English source -> Norwegian label) --- */
  var VALUE_LABELS = {
    'English': 'Engelsk',
    'Japanese': 'Japansk',
    'Chinese': 'Kinesisk'
  };
  var VALUE_SELECTOR = '#gf-tree .gf-option-block li .gf-label, ' +
    '.globo-selected-items-wrapper .gf-option-label, ' +
    '.globo-selected-items-wrapper .selected-item, ' +
    '.gf-refine-toggle .gf-option-label, ' +
    '.gf-selected-items .gf-option-label';

  function renameValues() {
    var nodes = document.querySelectorAll(VALUE_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-pkl-renamed')) continue;
      var textNode = null;
      for (var c = 0; c < el.childNodes.length; c++) {
        if (el.childNodes[c].nodeType === 3 && el.childNodes[c].nodeValue.trim()) { textNode = el.childNodes[c]; break; }
      }
      if (!textNode) continue;
      var raw = textNode.nodeValue;
      var key = raw.trim();
      var label = VALUE_LABELS[key];
      if (!label) {
        /* selected-filter chips render as "Språk: English" */
        var m = key.match(/^(.*:\s*)(English|Japanese|Chinese)$/);
        if (m) label = m[1] + VALUE_LABELS[m[2]];
      }
      if (label) {
        textNode.nodeValue = raw.replace(key, label);
        el.setAttribute('data-pkl-renamed', '1');
      }
    }
  }

  /* --- 1) search form placement --- */
  function holder(tree) {
    var h = tree.querySelector(':scope > .pkl-sidebar-search');
    if (!h) {
      h = document.createElement('div');
      h.className = 'pkl-sidebar-search';
      var contents = tree.querySelector('.gf-filter-contents');
      tree.insertBefore(h, contents || tree.firstChild);
    }
    return h;
  }

  function place() {
    if (moving) return;
    var form = document.querySelector('form.gf-controls-search-form');
    var tree = document.getElementById('gf-tree');
    var controls = document.getElementById('gf-controls-container');
    if (!form) return;

    moving = true;
    try {
      var heroHolder = document.querySelector('[data-pkl-search-holder]');
      if (heroHolder) {
        /* a collection hero with a search slot wins on every screen size */
        if (form.parentNode !== heroHolder) heroHolder.appendChild(form);
        var old = tree && tree.querySelector(':scope > .pkl-sidebar-search');
        if (old && !old.children.length) old.remove();
      } else if (DESKTOP.matches && tree && tree.offsetParent !== null) {
        var h = holder(tree);
        if (form.parentNode !== h) h.appendChild(form);
      } else if (controls && form.parentNode !== controls) {
        controls.insertBefore(form, controls.firstChild);
        var stale = tree && tree.querySelector(':scope > .pkl-sidebar-search');
        if (stale && !stale.children.length) stale.remove();
      }
    } finally {
      moving = false;
    }
  }

  /* --- 2b) active-filter chips: drop the group name when it equals the value ("På lager: På lager") --- */
  function dedupeChips() {
    var chips = document.querySelectorAll('.globo-selected-items-wrapper .selected-item a .selected-item');
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var group = chip.querySelector(':scope > span:not(.gf-label)');
      var value = chip.querySelector('.gf-label');
      if (!group || !value) continue;
      var same = group.textContent.trim().toLowerCase() === value.textContent.trim().toLowerCase();
      group.style.display = same ? 'none' : '';
    }
  }

  /* --- 4) collection hero: live in-stock count, random card fan, search button --- */
  var nb = window.Intl && Intl.NumberFormat ? new Intl.NumberFormat('nb-NO') : null;
  var STOCK_KEY = 'pkl-hero-stock-count-v1', STOCK_TTL = 10 * 60 * 1000, stockRequested = false;
  function setStockBadge(n) {
    var badge = document.querySelector('[data-pkl-stock-count]');
    if (!badge || !isFinite(n) || n < 0) return;
    var text = (nb ? nb.format(n) : String(n)) + ' ' + (badge.getAttribute('data-label') || '');
    if (badge.textContent !== text) badge.textContent = text;
  }
  function urlHasQueryOrFilter() {
    var has = false;
    try {
      new URL(window.location.href).searchParams.forEach(function (v, k) {
        if (k === 'q' && v) has = true;
        if (k.indexOf('filter.') === 0 && k !== 'filter.pa-lager') has = true;
      });
    } catch (e) {}
    return has;
  }
  /* Unfiltered in-stock count for the hero: Globo's init payload (cached per session).
     The sidebar facet is only trusted when no search/filter narrows it. */
  function heroStockCount() {
    var badge = document.querySelector('[data-pkl-stock-count]');
    if (!badge) return;
    try {
      var cached = JSON.parse(sessionStorage.getItem(STOCK_KEY));
      if (cached && Date.now() - cached.t < STOCK_TTL) { setStockBadge(Number(cached.n)); return; }
    } catch (e) {}
    if (!urlHasQueryOrFilter()) {
      var block = document.querySelector('#gf-tree .gf-option-block[data-filter-type="Availability"]');
      var opt = block && block.querySelector('li button[data-fvalue="1"] .gf-count, li a[data-fvalue="1"] .gf-count');
      if (opt) {
        var n = parseInt(String(opt.textContent).replace(/\D/g, ''), 10);
        if (isFinite(n)) { setStockBadge(n); try { sessionStorage.setItem(STOCK_KEY, JSON.stringify({ n: n, t: Date.now() })); } catch (e) {} return; }
      }
    }
    if (stockRequested || !window.fetch) return;
    var preload = document.querySelector('#gf-filter-preload[href]');
    if (!preload) return;
    stockRequested = true;
    fetch(preload.getAttribute('href'), { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) {
        var filters = Array.isArray(j && j.filters) ? j.filters : [];
        var av = null;
        for (var i = 0; i < filters.length; i++) {
          var f = filters[i];
          if (String(f.attribute || '').toLowerCase() === 'availability' || String(f.handle || '').toLowerCase() === 'pa-lager') { av = f; break; }
        }
        var vals = (av && av.values) || [], n = NaN;
        for (var k = 0; k < vals.length; k++) { if (String(vals[k].value) === '1') { n = parseInt(String(vals[k].count).replace(/\D/g, ''), 10); break; } }
        if (isFinite(n)) { setStockBadge(n); try { sessionStorage.setItem(STOCK_KEY, JSON.stringify({ n: n, t: Date.now() })); } catch (e) {} }
      })
      .catch(function () {});
  }

  /* Active search: put the URL's q back into the field after a reload and show a clear link. */
  var queryRestored = false;
  function heroActiveSearch() {
    var holder = document.querySelector('[data-pkl-search-holder]');
    var form = holder && holder.querySelector('form.gf-controls-search-form');
    if (!holder || !form) return;
    var input = form.querySelector('input[name="q"]');
    var q = '';
    try { q = new URL(window.location.href).searchParams.get('q') || ''; } catch (e) {}
    if (input && q && !input.value && !queryRestored) {
      queryRestored = true;
      input.value = q;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var note = holder.parentNode.querySelector('.pkl-hero__active');
    if (q) {
      if (!note) {
        note = document.createElement('p');
        note.className = 'pkl-hero__active';
        holder.parentNode.insertBefore(note, holder.nextSibling);
      }
      var clear = new URL(window.location.href);
      clear.searchParams.delete('q');
      clear.searchParams.delete('page');
      var label = 'Viser treff for «' + q + '»';
      if (note.getAttribute('data-q') !== q) {
        note.setAttribute('data-q', q);
        note.textContent = '';
        note.appendChild(document.createTextNode(label + ' · '));
        var a = document.createElement('a');
        a.href = clear.toString(); a.textContent = 'Nullstill søk';
        note.appendChild(a);
      }
    } else if (note) {
      note.remove();
    }
  }

  var fanDone = false;
  function fanShuffle(arr) { for (var i = arr.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = arr[i]; arr[i] = arr[j]; arr[j] = t; } return arr; }
  function fanRender(fan, picks) {
    var cards = fan.querySelectorAll('.pkl-hero__fan-card');
    var pending = cards.length, shown = false;
    function reveal() { if (!shown) { shown = true; fan.classList.add('is-ready'); } }
    for (var k = 0; k < cards.length; k++) {
      var pick = picks[k], a = cards[k], img = a.querySelector('img');
      a.href = pick.u; a.setAttribute('aria-label', pick.t || ''); img.alt = pick.t || '';
      img.onload = img.onerror = function () { if (--pending <= 0) reveal(); };
      img.src = pick.i;
    }
    setTimeout(reveal, 1500);
  }
  function fanUnique(list) {
    var seen = {}, out = [];
    for (var i = 0; i < list.length; i++) { var p = list[i]; if (!p || !p.i || !p.u || seen[p.u]) continue; seen[p.u] = 1; out.push(p); }
    return out;
  }
  function heroFan() {
    if (fanDone) return;
    var fan = document.querySelector('[data-pkl-fan]');
    if (!fan) return;
    fanDone = true;
    var poolEl = document.querySelector('[data-pkl-fan-pool]');
    var fallback = [];
    try { fallback = JSON.parse(poolEl ? poolEl.textContent : '[]') || []; } catch (e) { fallback = []; }
    fallback = fanUnique(fanShuffle(fallback));

    var handle = fan.getAttribute('data-collection');
    var total = parseInt(fan.getAttribute('data-count'), 10) || 0;
    var perPage = 50;
    var pages = Math.max(1, Math.ceil(total / perPage));

    function useFallback() {
      if (fallback.length >= 3) fanRender(fan, fallback.slice(0, 3)); else fan.remove();
    }
    if (!handle || !window.fetch || pages < 2) { useFallback(); return; }

    /* fetch one random page of the collection, keep in-stock products that have an image */
    var page = 1 + Math.floor(Math.random() * pages);
    fetch('/collections/' + handle + '/products.json?limit=' + perPage + '&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        var list = (data && data.products) || [];
        var picks = [];
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          var available = (p.variants || []).some(function (v) { return v.available; });
          var img = p.images && p.images[0] && p.images[0].src;
          /* Pokémon only: needs a pokemon* tag and must not be One Piece / Magic */
          var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
          var isPokemon = tags.some(function (t) { return t.indexOf('pokemon') === 0; }) &&
            !tags.some(function (t) { return t === 'one-piece' || t === 'magic' || t.indexOf('one-piece') === 0 || t.indexOf('magic') === 0; });
          if (!available || !img || !isPokemon) continue;
          picks.push({ u: '/products/' + p.handle, i: img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=520', t: p.title });
        }
        picks = fanUnique(fanShuffle(picks));
        if (picks.length < 3) picks = fanUnique(picks.concat(fallback));
        if (picks.length >= 3) fanRender(fan, picks.slice(0, 3)); else useFallback();
      })
      .catch(useFallback);
  }

  function heroSubmit(query) {
    var form = document.querySelector('.pkl-hero__search form.gf-controls-search-form');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (typeof query === 'string' && input) {
      input.value = query;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
  function heroSearchButton() {
    var btn = document.querySelector('[data-pkl-search-submit]');
    if (btn && !btn.getAttribute('data-wired')) {
      btn.setAttribute('data-wired', '1');
      btn.addEventListener('click', function () { heroSubmit(); });
    }
    var pills = document.querySelectorAll('[data-pkl-suggest]:not([data-wired])');
    for (var i = 0; i < pills.length; i++) {
      pills[i].setAttribute('data-wired', '1');
      pills[i].addEventListener('click', function (e) { heroSubmit(e.currentTarget.getAttribute('data-pkl-suggest') || ''); });
    }
  }

  /* --- 3) smooth filtering: flag <html> while Globo is fetching results.
     Only after a real filter/search/sort interaction: Globo's infinite scroll also passes
     through the loading state, and dimming/animating the grid then looks like flashing. --- */
  var lastTouch = 0, touchTimer = null;
  var TOUCH_SEL = '#gf-tree, #gf-controls, .gf-controls, .gf-filter-selection, .gf-refine-toggle, .gf-option-block, .gf-sort-by, .spf-sort-by, [data-pkl-search-holder], .pkl-hero__search, .pkl-hero__active, .pkl-hero__pill, #gf-filter-selection';
  function touch() {
    lastTouch = Date.now();
    document.documentElement.classList.add('pkl-filter-anim');
    clearTimeout(touchTimer);
    touchTimer = setTimeout(function () { document.documentElement.classList.remove('pkl-filter-anim'); }, 2500);
  }
  function onTouch(e) { var t = e.target; if (t && t.closest && t.closest(TOUCH_SEL)) touch(); }
  document.addEventListener('click', onTouch, true);
  document.addEventListener('change', onTouch, true);
  document.addEventListener('submit', onTouch, true);
  window.addEventListener('popstate', touch);
  touch(); /* initial render fades in */
  function flagLoading() {
    var loading = !!document.querySelector('#gf_pagination_wrap.spf-status-loading, .spf-status-loading');
    var recent = Date.now() - lastTouch < 4000;
    document.documentElement.classList.toggle('pkl-filtering', loading && recent);
  }

  var scheduled = false;
  function run() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      place();
      renameValues();
      dedupeChips();
      flagLoading();
      heroStockCount();
      heroActiveSearch();
      heroFan();
      heroSearchButton();
    });
  }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  DESKTOP.addEventListener ? DESKTOP.addEventListener('change', run) : DESKTOP.addListener(run);
  document.addEventListener('DOMContentLoaded', run);
  run();
})();

/* --- 5) safeguard: Globo's index can lag behind Shopify inventory, so a card that just sold
   can still be listed under "På lager". While the in-stock filter is active, hide cards the
   theme template itself marks as sold out (their own "Utsolgt" badge). --- */
(function () {
  function sync() {
    var p = new URLSearchParams(window.location.search);
    var on = p.get('filter.pa-lager') === '1';
    document.documentElement.classList.toggle('pkl-hide-soldout', on);
  }
  sync();
  window.addEventListener('popstate', sync);
  var push = history.pushState, rep = history.replaceState;
  history.pushState = function () { var r = push.apply(this, arguments); sync(); return r; };
  history.replaceState = function () { var r = rep.apply(this, arguments); sync(); return r; };
})();
